// NPM
import * as React from "react"
import { graphql } from "gatsby"
import _ from "lodash"

// Components
import Layout from "src/layouts/en"
import AnalyticsProducts from "src/components/pages/AnalyticsProducts/AnalyticsProducts"

const AnalyticsProductsPageEn = ({ location, data }) => {
  const topNav = data.topNav
  const sections = _.get(data, `analyticsProductsPage.sections`, [])
  const bottomNav = data.bottomNav
  const socialMedia = _.get(data, `socialMedia.nodes`, [])

  return (
    <Layout
      location={location}
      topNav={topNav}
      page={data.analyticsProductsPage}
      bottomNav={bottomNav}
      socialMedia={socialMedia}
    >
      <AnalyticsProducts sections={sections} />
    </Layout>
  )
}

export default AnalyticsProductsPageEn

export const query = graphql`
  query AnalyticsProductsPageEnQuery($id: String) {
    topNav: strapiTopNav(locale: { eq: "en" }) {
      ...topNavContent
    }

    analyticsProductsPage: strapiPage(id: { eq: $id }) {
      ...pageInformation
    }

    bottomNav: strapiBottomNav(locale: { eq: "en" }) {
      ...bottomNavContent
    }

    socialMedia: allStrapiSocialMedia(filter: { locale: { eq: "en" } }) {
      nodes {
        ...socialMedia
      }
    }
  }
`
